import { createContext } from "react";

const monitoringContext = createContext();

export default monitoringContext;
